import Main from '../../views/main'
import {ParentView} from '@/ladmin'
export default [
  {
    path: '/school',
    name: 'School',
    component: Main,
    meta: {
      label:'进校管理',
      disabled:true
    },
    children: [
      {
        path:'needSignList',
        name:'needSignList',
        component: () => import( '@/views/School/Sign/needSignList'),
        meta: {
          label: '教工申请补卡',
          singlePage: true, // 不在Main中显示
        }
      },
      {
        path:'selfExtraReviewList',
        name:'selfExtraReviewList',
        component: () => import( '@/views/School/Sign/selfList'),
        meta: {
          label: '个人申请记录（补卡）',
          singlePage: true, // 不在Main中显示
        }
      },
      {
        path:'firstExtraReviewList',
        name:'firstExtraReviewList',
        component: () => import( '@/views/School/Sign/firstReview'),
        meta: {
          label: '二级单位审核（补卡）',
          singlePage: true, // 不在Main中显示
        }
      },
      {
        path:'secondExtraReviewList',
        name:'secondExtraReviewList',
        component: () => import( '@/views/School/Sign/secondReview'),
        meta: {
          label: '人事处审核（补卡）',
          singlePage: true, // 不在Main中显示
        }
      },
      {
        path:'hospitalExtraReviewList',
        name:'hospitalExtraReviewList',
        component: () => import( '@/views/School/Sign/hospitalReview'),
        meta: {
          label: '校医院审核（补卡）',
          singlePage: true, // 不在Main中显示
        }
      },
      {
        path:'signApplyDetail',
        name:'signApplyDetail',
        component: () => import( '@/views/School/Sign/applyDetailBox'),
        meta: {
          label: '补卡申请详情'
        }
      },
      {
        path:'tempSignList',
        name:'tempSignList',
        component: () => import( '@/views/WX/tmpSelfSign/tempSignList'),
        meta: {
          label: '进校登记日志'
        }
      },
      {
        path:'record',
        name:'record',
        component: () => import( '@/views/School/Record/record'),
        meta: {
          label: '进校打卡补卡'
        }
      },
      {
        path:'blackAndWhite',
        name:'blackAndWhite',
        component: () => import( '@/views/School/blackAndWhite'),
        meta: {
          label: '黑白名单管理'
        }
      },
      {
        path:'teacherManagement',
        name:'teacherManagement',
        component: () => import( '@/views/School/Teacher/teacherManagement'),
        meta: {
          label: '轮班教师管理'
        }
      },
      {
        path:'selfApplList',
        name:'selfApplList',
        component: () => import( '@/views/School/Apply/applyList'),
        meta: {
          label: '个人申请列表'
        }
      },
      {
        name: 'selfApplListParent',
        path: 'selfApplListParent',
        component: ParentView,
        meta: {
          label: '个人申请列表'
        },
        redirect: {name: 'selfApplList'},
        children: [
          {
            name: 'newSelfApply',
            path: 'newSelfApply',
            component: () => import( '@/views/School/Apply/applyForm'),
            meta: {
              label: '新增进校申请'
            }
          },
        ]
      },
      {
        path:'secondReviewList',
        name:'secondReviewList',
        component: () => import( '@/views/School/Review/secondReviewList'),
        meta: {
          label: '业务部门审核'
        }
      },
      {
        name: 'secondReviewListParent',
        path: 'secondReviewListParent',
        component: ParentView,
        meta: {
          label: '业务部门审核'
        },
        redirect: {name: 'secondReviewList'},
        children: [
          {
            name: 'secondReviewDetailBox',
            path: 'secondReviewDetailBox',
            component: () => import( '@/views/School/Review/reviewDetailBox'),
            meta: {
              label: '申请详情'
            }
          },
        ]
      },
      {
        path:'allApplyList',
        name:'allApplyList',
        component: () => import( '@/views/School/allApplyList'),
        meta: {
          label: '进校申请查询'
        }
      },
      {
        name: 'allApplyListParent',
        path: 'allApplyListParent',
        component: ParentView,
        meta: {
          label: '进校申请查询'
        },
        redirect: {name: 'allApplyList'},
        children: [
        ]
      },
      {
        name: 'ApplyReviewDetailBox',
        path: 'applyReviewDetailBox',
        component: () => import( '@/views/School/Review/reviewDetailBox'),
        meta: {
          label: '申请详情'
        }
      },
      {
        path:'firstReviewList',
        name:'firstReviewList',
        component: () => import( '@/views/School/Review/firstReviewList'),
        meta: {
          label: '二级单位审核'
        }
      },
      {
        name: 'firstReviewListParent',
        path: 'firstReviewListParent',
        component: ParentView,
        meta: {
          label: '单位审核'
        },
        redirect: {name: 'firstReviewList'},
        children: [
          {
            name: 'firstReviewDetailBox',
            path: 'firstReviewDetailBox',
            component: () => import( '@/views/School/Review/reviewDetailBox'),
            meta: {
              label: '申请详情'
            }
          },
        ]
      },
    ]
  },
  {
    path: '/school/selfApplyList_wx',
    name: 'selfApplyList_wx',
    component: () => import('@/views/School/Apply/applyList_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/school/tempApply_wx',
    name: 'tempApply_wx',
    component: () => import('@/views/School/Apply/applyForm_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/school/tempReviewDetail_wx',
    name: 'tempReviewDetail_wx',
    component: () => import('@/views/School/Review/reviewDetailBox_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/school/firstReviewList_wx',
    name: 'firstReviewList_wx',
    component: () => import('@/views/School/Review/firstReviewList_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/school/secondReviewList_wx',
    name: 'secondReviewList_wx',
    component: () => import('@/views/School/Review/secondReviewList_wx'),
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
]
